import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { MaxBrainWidget } from './widget.model';

export class WidgetStateModel extends EntityStateModel<MaxBrainWidget> {}
